import { FC, useEffect, useState } from "react"
import { ModuleComponent, ModuleComponents } from "../../types/ContentStructure"
import { getProduct } from "../../services/ContentServices"
import { Box } from "@mui/material"
import ComponentType from "../../components/component_type/ComponentType"
import { slugify } from "../../utils/utils"

interface ProductPageProps {
    product_name: string
}
const ProductPage: FC<ProductPageProps> = ({ product_name }) => {
    const [product, setProduct] = useState<ModuleComponents>()
    useEffect(() => {
        const fetchData = async () => {
            const response = await getProduct(slugify(product_name!));
            setProduct(response.data);
        }
        fetchData();
    }, [product_name])

    if (!product) {
        return null
    }
    return (

        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
        }}>
            <Box sx={{
                maxWidth: '1920px',
                display: 'flex',
                width: '100%',
                flexDirection: 'column',
            }}>

                {product.components.map((item: ModuleComponent, idx: number) => {
                    return <ComponentType key={idx} component={item.component} />
                })}
            </Box>
        </Box>
    )
}

export default ProductPage
